import { Language, Subsidiary } from '@coolblue-development/constants';
import { Flex, freddyTheme, Typography } from '@coolblue-development/freddy';
import selectSwitchCountryTrigger from '@coolblue-development/ga4-events/triggers/RecruitmentHeader/selectSwitchCountryTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { useTranslation } from '@i18n/useTranslation';
import { LocalizedReadableSubsidiaryMap } from '@utils/locale';
import React from 'react';

import { flagMap } from '../flagMap';

type Props = {
  subsidiary: Subsidiary;
  isVacancyPage: boolean;
  pageLanguage: Language;
  pageSubsidiary: Subsidiary;
  showAllLanguageOptions?: boolean;
  setShowAllLanguageOptions?: (showAllLanguageOptions: boolean) => void;
};

export const SubsidiaryOption = ({
  subsidiary,
  pageSubsidiary,
  pageLanguage,
  isVacancyPage,
  showAllLanguageOptions,
  setShowAllLanguageOptions
}: Props) => {
  const { t } = useTranslation('header.languageSwitcher');
  const { trackEvent } = useAnalytics();

  const readableSubsidiaryName = LocalizedReadableSubsidiaryMap[subsidiary][pageLanguage];

  return (
    <Flex
      alignItems='center'
      justifyContent='space-between'
      padding={`${freddyTheme.spacing[200]} ${freddyTheme.spacing[300]}`}
    >
      <Flex alignItems='center' gap={200}>
        {flagMap[subsidiary]}
        <Typography fontWeight={freddyTheme.typography.fontWeight.openSans.bold}>
          {readableSubsidiaryName}
        </Typography>
      </Flex>
      {subsidiary === pageSubsidiary &&
        !isVacancyPage &&
        !showAllLanguageOptions &&
        setShowAllLanguageOptions && (
          <Typography
            component='button'
            variant='caption'
            fontWeight={freddyTheme.typography.fontWeight.openSans.normal}
            sx={{ border: 'unset', background: 'unset', '&:hover': { cursor: 'pointer' } }}
            onMouseDown={event => event.preventDefault()}
            onClick={() => {
              trackEvent(selectSwitchCountryTrigger());
              setShowAllLanguageOptions(true);
            }}
          >
            {t('changeCountry')}
          </Typography>
        )}
    </Flex>
  );
};
